<template>
    <div>
        <p style="display: flex;
            font-size: 30px;
            flex-direction: row;
            height: 45px;
            color: rgb(221,114,2); 
            border-bottom: solid 0.06rem rgb(193,193,193);">
            Relation between major depressive disorder and its similar diseases
        </p>
        <el-card style="width:100%;
               height:auto;
               margin-left: auto;
               margin-right: auto;
               margin-top: 15px;
               font-size: 14px;">
               <div style="width:95%;display: inline-block;vertical-align: middle;margin:auto;font-size: 16px;text-align: left;line-height: 23px;">
                In this visualization section, 
                we jointly analyzed the same omics data between major depressive disorder and its similar diseases. 
                <ul>
                <li>From the perspective of disease,
                we show the overlap of various omics data among different diseases by the <strong style="font-size:20px;">Venn plot</strong>. </li>
                <li>From the perspective of omics data,
                we show the relationship between different omics data entered and four diseases by the <strong style="font-size:20px;">relationship network</strong>.</li>
                </ul>
               </div>
        </el-card>
        <el-tabs style="height:auto;margin-top: 50px;" type="border-card" v-model="activePane">
            <el-tab-pane label="Venn plot" name="venn">
                <SharedGeneVue></SharedGeneVue>
            </el-tab-pane>
            <el-tab-pane label="Relationship network" name="relationship">
                <NetworkVue></NetworkVue>
            </el-tab-pane>
        </el-tabs>
    </div>
   
</template>

<script>

import SharedGeneVue from './RelationPane/SharedGene.vue';
import NetworkVue from './RelationPane/Network.vue';
export default({
    components:{
        SharedGeneVue,
        NetworkVue
    },
    data(){
        return{
            activePane:"venn",
            
        }
    },
    mounted(){
        this.vennFields=this.snpFields
    },
    methods:{
       
    }

})

</script>
